import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Profile from './components/Profile';
import Dashboard from './components/Dashboard';
import AddApartment from './components/add_apartment/AddApartment';
import EditApartment from './components/edit_apartment/EditApartment';
import RentHistory from './components/rent_history/RentHistory';
import ApartmentsPage from './components/Apartments';
import TermsOfUse from './components/legal/TermsOfUse';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import "slick-carousel/slick/slick.css";  // Import Slick carousel CSS
import "slick-carousel/slick/slick-theme.css";  // Import Slick theme CSS
import { ModalProvider, useModal } from './context/ModalContext';
import ModalDialog from './components/ModalDialog';

const AppContent = () => {
    const { isOpen, closeModal, modalContent } = useModal();
    return (
        <>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/apartments" element={<ApartmentsPage />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/add-apartment" element={<AddApartment />} />
                <Route path="/edit-apartment/:id" element={<EditApartment />} />
                <Route path="/rent-history/:apartmentId" element={<RentHistory />} />
                <Route path="/terms-of-use" element={<TermsOfUse />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            </Routes>
            <ModalDialog open={isOpen} onClose={closeModal}>
                {modalContent}
            </ModalDialog>
        </>
    );
};

const App = () => {
    return (
        <ModalProvider>
            <AppContent />
        </ModalProvider>
    );
};

export default App;
